/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { doc } from "firebase/firestore";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Modal from "react-modal";
import { Input, message as antMessage } from "antd";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Form from "react-bootstrap/Form";
import { db } from "../../../firebase";
import { Check, RefreshCw, X } from "lucide-react";
import { useTranslation } from "react-i18next";
export default function ActivationWeinsight() {
  const MySwal = withReactContent(Swal);
  const [showSideBar, setShowSideBar] = useState(true);
  const account = useSelector((state) => state.AccountReducer);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
    .swal2-container {
      z-index: 9999999999 !important;
    }
    .swal2-popup {
      direction: rtl;
      text-align: right;
    }
  `;
    document.head.appendChild(style);

    return () => document.head.removeChild(style);
  }, []);

  const [selectedService, setSelectedService] = useState(false);
  const store = useSelector((state) => state.StoreReducer);

  const handleOpenModal = (company) => {
    setSelectedService(company);
  };

  const handleCloseModal = () => {
    setSelectedService(null);
  };

  const [activeFilter, setActiveFilter] = useState("detailsService");

  const [data, setData] = useStoreFormDraft(store);

  const [messageApi, contextHolder] = antMessage.useMessage(); // Using the renamed import

  const success = () => {
    messageApi.open({
      type: "success",
      content: t("insightadsActivation.facebook.messages.success"),
      style: {
        marginTop: "10vh",
        direction: "rtl",
      },
    });
    setTimeout(messageApi.destroy, 2500);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const minLength = 150; // الحد الأدنى للطول المطلوب
    const token = data.accessTokenFacebookAds || "";

    if (token.length <= minLength) {
      await Swal.fire({
        icon: "warning",
        title: t("insightadsActivation.facebook.messages.enable.warning.title"),
        text: t("insightadsActivation.facebook.messages.enable.warning.text"),
        confirmButtonText: t(
          "insightadsActivation.facebook.messages.enable.warning.confirm"
        ),
        customClass: {
          popup: "swal2-rtl",
        },
        didOpen: () => {
          document.querySelector(".swal2-container").style.zIndex =
            "9999999999";
        },
      });
      return;
    }

    setLoading(true);
    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      await Swal.fire({
        icon: "success",
        title: t("insightadsActivation.facebook.messages.enable.success.title"),
        text: t("insightadsActivation.facebook.messages.enable.success.text"),
        confirmButtonText: t(
          "insightadsActivation.facebook.messages.enable.success.confirm"
        ),
        customClass: {
          popup: "swal2-rtl",
        },
        didOpen: () => {
          document.querySelector(".swal2-container").style.zIndex =
            "9999999999";
        },
      });

      success(); // Si tu veux exécuter une autre fonction après succès
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: t("insightadsActivation.facebook.messages.enable.error.title"),
        text: t("insightadsActivation.facebook.messages.enable.error.text"),
        confirmButtonText: t(
          "insightadsActivation.facebook.messages.enable.error.confirm"
        ),
        customClass: {
          popup: "swal2-rtl",
        },
        didOpen: () => {
          document.querySelector(".swal2-container").style.zIndex =
            "9999999999";
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDisable = async (e) => {
    e.preventDefault();

    // Vérifier si la plateforme est déjà désactivée
    if (!data.accessTokenFacebookAds) {
      await Swal.fire({
        icon: "info",
        title: t(
          "insightadsActivation.facebook.messages.disable.notEnabled.title"
        ),
        text: t(
          "insightadsActivation.facebook.messages.disable.notEnabled.text"
        ),
        didOpen: () => {
          document.querySelector(".swal2-container").style.zIndex =
            "9999999999";
        },
      });
      return;
    }

    try {
      setLoading(true);

      // Mettre à jour les données (désactivation)
      const updatedData = {
        ...data,
        accessTokenFacebookAds: "",
      };

      await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
      dispatch(applyStoreDraft(store, updatedData));
      setLoading(false);

      await Swal.fire({
        icon: "success",
        title: t(
          "insightadsActivation.facebook.messages.disable.success.title"
        ),
        text: t("insightadsActivation.facebook.messages.disable.success.text"),
        didOpen: () => {
          document.querySelector(".swal2-container").style.zIndex =
            "9999999999";
        },
      });

      // Mettre à jour l'état local si nécessaire
      setData(updatedData);
    } catch (error) {
      setLoading(false);

      await Swal.fire({
        icon: "error",
        title: t("insightadsActivation.facebook.messages.disable.error.title"),
        text: t("insightadsActivation.facebook.messages.disable.error.text"),
        didOpen: () => {
          document.querySelector(".swal2-container").style.zIndex =
            "9999999999";
        },
      });

      console.error("Error disabling Facebook Meta API:", error);
    }
  };

  return (
    <div className="h-fit overflow-x-hidden dark:!bg-[#181819]">
      {contextHolder} {/* Add the context holder for Ant Design message */}
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-xl font-bold text-[#9e68ba] mb-2">
          {t("insightadsActivation.title")}
        </h1>
        <p className="text-gray-600 dark:!text-gray-300">
          {t("insightadsActivation.description")}
        </p>
      </div>
      {/* Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {/* Facebook Meta Card */}
        <div className="bg-white dark:!bg-[#222222] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden hover:shadow-md transition-all duration-200">
          <div className="p-4">
            <div className="flex items-start gap-3">
              <div className="rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-2 w-16 h-16 flex items-center justify-center bg-white dark:!bg-[#181919] shrink-0">
                <Image
                  src="/facebook3.png"
                  alt={t("insightadsActivation.cards.facebook.title")}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div>
                <h3 className="font-bold text-xl text-[#9e68ba] mb-1">
                  {t("insightadsActivation.cards.facebook.title")}
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm mb-3 line-clamp-2">
                  {t("insightadsActivation.cards.facebook.description")}
                </p>
                <button
                  onClick={handleOpenModal}
                  className="inline-flex items-center px-3 py-1.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white text-sm font-medium rounded-lg transition-colors"
                >
                  {t("insightadsActivation.cards.facebook.button")}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* TikTok Ads Card */}
        <div className="bg-white dark:!bg-[#222222] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden hover:shadow-md transition-all duration-200">
          <div className="p-4">
            <div className="flex items-start gap-3">
              <div className="rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-2 w-16 h-16 flex items-center justify-center bg-white dark:!bg-[#181919] shrink-0">
                <Image
                  src="https://cdn-icons-png.flaticon.com/128/15713/15713399.png"
                  alt={t("insightadsActivation.cards.tiktok.title")}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div>
                <h3 className="font-bold text-xl text-[#9e68ba] mb-1">
                  {t("insightadsActivation.cards.tiktok.title")}
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm mb-3 line-clamp-2">
                  {t("insightadsActivation.cards.tiktok.description")}
                </p>
                <button
                  className="inline-flex items-center px-3 py-1.5 bg-yellow-100 dark:!bg-[#3c3a3d] text-yellow-800 dark:text-yellow-300 border border-yellow-500 dark:!border-yellow-600 text-sm font-medium rounded-lg cursor-not-allowed"
                  disabled
                >
                  {t("insightadsActivation.cards.tiktok.button")}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* SnapChat Ads Card */}
        <div className="bg-white dark:!bg-[#222222] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden hover:shadow-md transition-all duration-200">
          <div className="p-4">
            <div className="flex items-start gap-3">
              <div className="rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-2 w-16 h-16 flex items-center justify-center bg-white dark:!bg-[#181919] shrink-0">
                <Image
                  src="/Snapchat.png"
                  alt={t("insightadsActivation.cards.snapchat.title")}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div>
                <h3 className="font-bold text-xl text-[#9e68ba] mb-1">
                  {t("insightadsActivation.cards.snapchat.title")}
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm mb-3 line-clamp-2">
                  {t("insightadsActivation.cards.snapchat.description")}
                </p>
                <button
                  className="inline-flex items-center px-3 py-1.5 bg-yellow-100 dark:!bg-[#3c3a3d] text-yellow-800 dark:text-yellow-300 border border-yellow-500 dark:!border-yellow-600 text-sm font-medium rounded-lg cursor-not-allowed"
                  disabled
                >
                  {t("insightadsActivation.cards.snapchat.button")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Facebook Meta Modal */}
      <Modal
        isOpen={selectedService}
        onRequestClose={handleCloseModal}
        className="fixed inset-0 z-[9999999] flex items-center justify-center"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
        contentLabel="Facebook Meta Activation"
        ariaHideApp={false}
        style={{
          overlay: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 99999,
          },
          content: {
            position: "relative",
            top: "auto",
            left: "auto",
            right: "auto",
            bottom: "auto",
            border: "none",
            background: "transparent",
            overflow: "visible",
            borderRadius: "0",
            outline: "none",
            padding: "0",
            width: "80%",
            height: "auto",
            maxHeight: "80vh",
            margin: "0 auto",
          },
        }}
      >
        <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-xl overflow-hidden w-full">
          {/* Tab Buttons */}
          <div className="flex border-b border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <button
              className={`flex-1 py-3 px-4 text-center font-medium transition-colors ${activeFilter === "detailsService"
                ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                }`}
              onClick={() => setActiveFilter("detailsService")}
            >
              {t("services.service_details")}
            </button>
            <button
              className={`flex-1 py-3 px-4 text-center font-medium transition-colors ${activeFilter === "activeService"
                ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                }`}
              onClick={() => setActiveFilter("activeService")}
            >
              {t("services.activate_service")}
            </button>
          </div>

          {/* Modal Content */}
          <div className="max-h-[60vh] overflow-y-auto">
            {/* Details Service Tab */}
            {activeFilter === "detailsService" && (
              <div className="p-6">
                <div className="flex flex-col md:flex-row gap-8 h-full">
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                      {t("insightadsActivation.facebook.details.title")}{" "}
                      <span className="text-[#9e68ba]">
                        {t("services.services.facebook_api_conversions.name")}
                      </span>
                    </h3>
                    <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
                      {t("insightadsActivation.facebook.details.description")}
                    </p>
                    <div className="bg-[#fcf6ff] dark:!bg-[#222222] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-4">
                      <h4 className="font-medium text-[#9e68ba] mb-2">
                        {t(
                          "insightadsActivation.facebook.details.featuresTitle"
                        )}
                      </h4>
                      <ul className="space-y-2 text-gray-700 dark:text-gray-300">
                        <li className="flex items-center">
                          <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                          {t(
                            "insightadsActivation.facebook.details.features.0"
                          )}
                        </li>
                        <li className="flex items-center">
                          <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                          {t(
                            "insightadsActivation.facebook.details.features.1"
                          )}
                        </li>
                        <li className="flex items-center">
                          <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                          {t(
                            "insightadsActivation.facebook.details.features.2"
                          )}
                        </li>
                        <li className="flex items-center">
                          <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                          {t(
                            "insightadsActivation.facebook.details.features.3"
                          )}
                        </li>
                      </ul>
                    </div>
                    <a
                      className="inline-flex items-center px-4 py-2 text-[#9e68ba] bg-[#fcf6ff] dark:!bg-[#3c3a3d] rounded-lg font-medium transition-colors hover:bg-[#faf1ff] dark:hover:bg-[#2a2a2a]"
                      href="https://www.youtube.com/watch?v=bMm58tWxZ-A"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 ml-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                        <path
                          fillRule="evenodd"
                          d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      {t("insightadsActivation.facebook.details.video")}
                    </a>
                  </div>
                  <div className="flex-1">
                    <img
                      src="/metaToken.png"
                      alt={t("ui.metaApiIntegration")}
                      className="w-full h-auto rounded-lg shadow-sm"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Active Service Tab */}
            {activeFilter === "activeService" && (
              <div className="min-h-[400px] h-fit p-6">
                <div className="bg-white dark:!bg-[#222222] rounded-lg shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <form onSubmit={handleSubmit}>
                    <div className="p-6">
                      <h3 className="text-lg font-semibold text-[#9e68ba] mb-4">
                        {t("insightadsActivation.facebook.activation.title")}
                      </h3>
                      <p className="text-gray-600 dark:text-gray-300 mb-6">
                        {t(
                          "insightadsActivation.facebook.activation.description"
                        )}
                      </p>

                      <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                          {t(
                            "insightadsActivation.facebook.activation.tokenLabel"
                          )}
                        </label>

                        <div className="relative">
                          <input
                            type="text"
                            className="w-full p-3 pr-10 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 transition-colors bg-white dark:!bg-[#181919] text-gray-800 dark:text-gray-200"
                            placeholder={t(
                              "insightadsActivation.facebook.activation.tokenPlaceholder"
                            )}
                            value={data.accessTokenFacebookAds || ""}
                            onChange={(e) =>
                              setData({
                                ...data,
                                accessTokenFacebookAds: e.target.value,
                              })
                            }
                          />
                        </div>

                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                          {t(
                            "insightadsActivation.facebook.activation.tokenHint"
                          )}
                        </p>
                      </div>

                      <div className="d-flex justify-content-between mt-4">
                        <button
                          type="submit"
                          disabled={loading}
                          className={`px-6 py-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium rounded-lg transition-colors flex items-center ${loading ? "opacity-70 cursor-not-allowed" : ""
                            }`}
                        >
                          {loading ? (
                            <>
                              <RefreshCw
                                className="animate-spin ml-2"
                                size={18}
                              />
                              {t(
                                "insightadsActivation.facebook.activation.enabling"
                              )}
                            </>
                          ) : (
                            <>
                              <Check className="ml-2" size={18} />
                              {t(
                                "insightadsActivation.facebook.activation.enable"
                              )}
                            </>
                          )}
                        </button>
                        <Button
                          variant="danger"
                          className="d-flex align-items-center justify-content-center"
                          onClick={handleDisable}
                          style={{
                            borderRadius: "0.5rem",
                            padding: "0.5rem 1.5rem",
                            minWidth: "150px",
                          }}
                        >
                          <X className="ml-2" size={18} />
                          {t(
                            "insightadsActivation.facebook.activation.disable"
                          )}
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>

          {/* Modal Footer */}
          <div className="border-t border-[#fbf4ff] dark:!border-[#3c3a3d] p-4 bg-gray-50 dark:!bg-[#222222] flex justify-start">
            <button
              className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white bg-white dark:!bg-[#181919] border border-gray-300 dark:!border-[#3c3a3d] hover:bg-gray-50 dark:hover:bg-[#2a2a2a] font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center gap-2"
              onClick={handleCloseModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              {t("insightadsActivation.facebook.activation.close")}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

